import React, { Component } from 'react';
import ProjectPage from '../../components/ProjectPage';
import Table from '../../components/Table';

class Deflander extends Component {
  render() {
    return (
    <ProjectPage title="Deflander">

      <div className='project-page-part'>

        <Table className="centered" data={{
          Status : "Dropped",
          Type : "School project",
          Engine : "Unity",
          Language : "C#",
          Duration : "3 months",
          Date : "2019"
        }}/>

      </div>

      <div className='project-page-part'>

        <h3>Context :</h3>

        <p className='basic-text'>
          During my last year of High school I had to make a project of my choosing in Computer science.<br/>
          I decided to make a video game.<br/>
          The game was never finished, and I didn't continue it afterwards.
        </p>

      </div>

      <div className='project-page-part'>

        <h3>Game :</h3>

        <p className='basic-text'>
          Deflander is a strategy game where you have to develop your island and resist the hordes of pirates.
        </p>

      </div>

    </ProjectPage>
    );
  }
}

export default Deflander;